export default __webpack_public_path__ + "static/media/shape1.16eb1e0f.svg";